<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmSinister"
          :title="$lang.Sinister.Search.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSearchButton="true"
          :showExportButton="false"
          :showNewRegulationButton="hasRole(this.roles.RW_REG_TABDETAILS)"
          :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
          v-on:Clear="onClear"
          v-on:Search="onSearch"
          v-on:Export="onExport"
          v-on:NewRegulation="onClearAllTabs">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.Sinister.Search.Insurer}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.insurance.value"
                      :options="getAllInsurer"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxProduct"> {{$lang.Sinister.Search.Product}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.product.value"
                      :options="getAllProduct" />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtInsured"> {{$lang.Sinister.Search.Insured}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-user"></i></span>
            <b-form-input type="text"
                          name="txtInsured"
                          :placeholder="$lang.Sinister.Search.PlaceholderEnterInsured"
                          v-model="form.insured.value"
                          :size="form.insured.maxlength"
                          :state="form.insured.state"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure">{{$lang.Sinister.Search.Stage}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.stage.value"
                      :disabled="this.isRegulator"
                      :options="getAllStage"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtCodeSinister"> {{$lang.Sinister.Search.SinisterCode}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtCodeSinister"
                          :placeholder="$lang.Sinister.Search.PlaceholderEnteSinisterCode"
                          v-model="form.sinisterCode.value"
                          :size="form.sinisterCode.maxlength"
                          :state="form.sinisterCode.state"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtPlate"> {{$lang.Sinister.Search.Plate}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPlate"
                          :placeholder="'BRA-12J4'"
                          v-model="form.plate.value"
                          :size="form.plate.maxlength"
                          :required="form.plate.required"
                          :state="form.plate.state"
                          />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDateStart">{{$lang.Sinister.Search.DateStart}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDateStart" v-model="form.sinisterDateStart.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDateEnd"> {{$lang.Sinister.Search.DateEnd}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDateEnd" v-model="form.sinisterDateEnd.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.Sinister.Search.Expert}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.expert.value"
                      :disabled="isRegulator"
                      :options="getAllExpert"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.Sinister.Search.RegulationType}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.regulationType.value"
                      :options="getAllRegulationType"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.Sinister.Search.SchedulingType}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.schedulingType.value"
                      :options="getAllSchedulingType"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxType"><small v-show="form.ranking.required" class="text-danger">*</small> {{ $lang.Sinister.Search.AutoType }}:</label>
          <div class="input-group">
            <span class="input-group-addon input-group-addon-icondropdown"><i class="fa fa-truck"></i></span>
            <b-form-select v-model="form.ranking.value"
                          :options="form.ranking.options"
                          :state="form.ranking.state"
                          class="mb-3"
                          name="cbxType">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="1">{{$lang.AutoType.Ranking.Light}}</option>
                <option :value="2">{{$lang.AutoType.Ranking.Heavy}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.Sinister.Search.Lighthouse}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.lighthouse.value"
                      :options="
                      [
                        { label: $lang.Sinister.Search.LighthouseOpt.Green, value: '1', color: 'green' },
                        { label: $lang.Sinister.Search.LighthouseOpt.Yellow, value: '2' },
                        { label: $lang.Sinister.Search.LighthouseOpt.Red, value: '3' },
                      ]">
            </v-select>
          </div>
        </div>
        <div class="col-md-2">
            <label for="cbxBudgetSystem">{{$lang.Sinister.Details.BudgetSystem}}:</label>
            <div class="input-group">
              <v-select style="width: 100%"
                      multiple
                      v-model="form.budgetSystem.value"
                      :options="getAllBudgetSystem"/>
            </div>
        </div>
        <div class="col-md-2">
            <label for="cbxAnalyst">{{$lang.Sinister.Details.Analyst}}:</label>
            <div class="input-group">
              <v-select style="width: 100%"
                      multiple
                      v-model="form.analyst.value"
                      :options="getAllAnalyst"/>
            </div>
        </div>
      </div>
      <div class="form-group row">

      </div>
    </Forms>

    <Tables ref="tableGrid"
      :columns="[
        $lang.Sinister.Search.DataTable.Sinister,
        $lang.Sinister.Search.DataTable.Insurer,
        $lang.Sinister.Search.DataTable.SchedulingType,
        $lang.Sinister.Search.DataTable.Plate,
        $lang.Sinister.Search.DataTable.Stage,
        $lang.Sinister.Search.DataTable.Date,
        $lang.Sinister.Search.DataTable.Responsible,
        $lang.Sinister.Search.DataTable.Analyst,
        $lang.Sinister.Search.DataTable.Conclusion,
        $lang.Sinister.Search.DataTable.Lighthouse
      ]"
      :showSearch="false"
      :showPrint="false"
      :showDownload="true"
      :showFullscreen="true"
      :messageTipFooter="$lang.Common.ClickToSelect"
      v-on:Load="onSearch"
      v-on:Fullscreen="onFullscreen"
      v-on:SaveFile="onExport"
      >
      <tr v-for="obj in this.objList" v-bind:key="obj.ID">
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="`${obj.sinisterCode} - ${obj.sinisterVersion}`" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.insurance.name" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.schedulingTypeString" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.plate" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.stage.name" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.receiptDate" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.experts != null && obj.experts.length >= 1 ? obj.experts[0].label : '' " />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.responsible.name" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.regulationAutoDigitation != null ? obj.regulationAutoDigitation.typeConclusionDescription : ''" />
        <TableColumn :IsLighthouse="true"                       :status="obj.status" :value="obj.lightHouse && Number.isInteger(obj.lightHouse) ? obj.lightHouse.toString() : '0'" :description="obj.hours"/>
      </tr>
    </Tables>

  </div>
</template>
<script>
import SinisterSearch from './sinistersearch.js'

export default SinisterSearch
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/search/SinisterSearch.vue